import { HTTP } from '@/core';
import { ServiceIntervalItem, StoreServiceInterval } from './interface';

export class VehicleServiceIntervalDictionaryService {
  static async store(dictionaryUrl: string, serviceInterval: StoreServiceInterval): Promise<ServiceIntervalItem> {
    const { data } = await HTTP.post(`vehicles/${dictionaryUrl}`, serviceInterval);

    return data;
  }

  static async findAll(dictionaryUrl: string, my?: boolean): Promise<ServiceIntervalItem[]> {
    const queryParam = my ? '?my=true' : '';
    const { data } = await HTTP.get(`vehicles/${dictionaryUrl}${queryParam}`);

    return data;
  }

  static async update(
    dictionaryUrl: string,
    id: string,
    serviceInterval: Partial<StoreServiceInterval>,
  ): Promise<ServiceIntervalItem> {
    const { data } = await HTTP.patch(`vehicles/${dictionaryUrl}/${id}`, serviceInterval);

    return data;
  }

  static async delete(dictionaryUrl: string, id: string): Promise<void> {
    await HTTP.delete(`vehicles/${dictionaryUrl}/${id}`);
  }
}
